angular.module('iqxCore')
	.controller('CandidateDiaryAvailabilityCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, $location) {
		$scope.repeatTypes = [
			{ id: 0, name: "None" },
			{ id: 500, name: "Every day" },
			{ id: 501, name: "Every week day (Monday to Friday)" },
			{ id: 503, name: "Every weekend (Saturday and Sunday)" },
			{ id: 502, name: "Every week" }
		]

		$scope.diaryAvailObj = { repeat: 0 }

		$scope.templateSelected = function () {
			if ($scope.diaryAvailObj.type && $scope.diaryAvailObj.type.EventFrom) {
				// if there is a event from in the template, set the time from
				$scope.diaryAvailObj.timeFrom = moment($scope.diaryAvailObj.type.EventFrom, "HH:mm")
			} else {
				// if there is no event from, clear the time from
				$scope.diaryAvailObj.timeFrom = undefined
			}
			if ($scope.diaryAvailObj.type && $scope.diaryAvailObj.type.EventTo) {
				// if there is a event to in the template, set the time to
				$scope.diaryAvailObj.timeTo = moment($scope.diaryAvailObj.type.EventTo, "HH:mm")
			} else {
				// if there is no event to, clear the time to
				$scope.diaryAvailObj.timeTo = undefined
			}
		}


		$scope.submitAvailList = function () {
			if (!$scope.diaryAvailObj.type) {
				FormSvc.alert("Missing type", "Please select an availability type.", "error")
			} else if (!$scope.diaryAvailObj.timeFrom) {
				FormSvc.alert("Missing time", "Please select the time at which you want your availability to start from.", "error")
			} else if (!$scope.diaryAvailObj.timeTo) {
				FormSvc.alert("Missing time", "Please select the time at which you want your availability to end at.", "error")
			} else if (!$scope.diaryAvailObj.date) {  // do rest of validation stuffs here!!!
				FormSvc.alert("Missing date", "Please enter a date.", "error")
			} else if (!$scope.diaryAvailObj.repeat && $scope.diaryAvailObj.repeat !== 0) {
				FormSvc.alert("Missing type", "Please select a repeat option.", "error")
			} else if (!$scope.diaryAvailObj.dateTo && $scope.diaryAvailObj.repeat != 0) {
				FormSvc.alert("Missing type", "Please select a the date you would like the availability to repeat until.", "error")
			} else {
				var diaryAvailArray = []
				var paramList = ""
				var paramspace = "|"
				var paramnewline = "*"

				if ($scope.diaryAvailObj.repeat > 0) {
					// build array of stuffs based on the selected repeat...
					diaryAvailArray.push(angular.copy($scope.diaryAvailObj))
					var originalDateFrom = moment($scope.diaryAvailObj.date)
					while ($scope.diaryAvailObj.date.isBefore($scope.diaryAvailObj.dateTo, 'day')) {
						$scope.diaryAvailObj.date.add(1, 'days')
						// repeat every day___________________repeat week days only______________________________________________________________________________________________________________repeat every week (on same days of week)
						if (
							$scope.diaryAvailObj.repeat === 500 ||
							($scope.diaryAvailObj.repeat === 501 && $scope.diaryAvailObj.date.format('d') > 0 && $scope.diaryAvailObj.date.format('d') < 6) ||
							($scope.diaryAvailObj.repeat === 502 && $scope.diaryAvailObj.date.format('d') === originalDateFrom.format('d')) ||
							($scope.diaryAvailObj.repeat === 503 && ($scope.diaryAvailObj.date.format('d') === '0' || $scope.diaryAvailObj.date.format('d') === '6'))
						) {
							diaryAvailArray.push(angular.copy($scope.diaryAvailObj))
						}
					}
					$scope.diaryAvailObj.date = originalDateFrom
				} else {
					// there is no repeat so just add it once
					diaryAvailArray.push(angular.copy($scope.diaryAvailObj))
				}

				if (diaryAvailArray.length > 100) {
					FormSvc.alert("No Availability Submitted", "Your availability has not been submitted as you are trying to repeat it " + diaryAvailArray.length + " times, the maximum is 100", "error")
				} else {
					angular.forEach(diaryAvailArray, function (value, key) {
						paramList += value.type.Grp + paramspace

						// date from
						paramList += moment(value.date).format('YYYY-MM-DD') + paramspace
						// pTimeFrom
						paramList += moment(value.timeFrom).format('HH:mm') + paramspace
						// pTimeTo
						paramList += moment(value.timeTo).format('HH:mm') + paramspace
						// pIDCode     use this one to send in event id code from selected type
						paramList += (value.type.EventID || "") + paramspace


						// Not needed!

						// pAction
						paramList += paramspace
						// pNote
						paramList += paramspace

					}) // end of for each loop

					if (paramList && paramList != "") {
						return ApiSvc.exec($scope, 'call/NetCandidateDiaryAddMultipleEvents', {
							"pParamString": paramList,
							"pPersonID": ApplicationSvc.currentUser.personID
						})
							.then(function () {
								var availabilityType = ""
								if ($scope.diaryAvailObj.type.Grp === "A") {
									availabilityType = "Availability"
								} else if ($scope.diaryAvailObj.type.Grp === "H") {
									availabilityType = "Holiday"
								} else if ($scope.diaryAvailObj.type.Grp === "U") {
									availabilityType = "Unavailability"
								}

								FormSvc.alert(availabilityType + " Submitted", "Your " + availabilityType.toLowerCase() + " has successfully been Submitted.", "success")
								$scope.diaryAvailObj = { repeat: 0 }
								$location.url("/canddiary")
							})
					} else {  // if there is a missing field another alert be shown so this one is not needed
						FormSvc.alert("No Availability Submitted", "Your availability has not been Submitted as you have entered no values.", "error")
					}
				}
			}
		}



		$scope.getAvailabilityTemplates = function () {
			// get list of templates from procedure
			return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateShiftTemplates', fetchTarget: 'AvailabilityTemplatesTemp', multiRow: true })
				.then(function () {
					// sort though the list returned from the procedure and put them into the appropriate groups
					$scope.AvailabilityTemplates = { a: { label: "Available", templates: [] }, u: { label: "Unavailable", templates: [] }, h: { label: "Holiday", templates: [] } }
					angular.forEach($scope.AvailabilityTemplatesTemp, function (value, key) {
						if (value.Grp == "A") {
							$scope.AvailabilityTemplates.a.templates.push(value)
						} else if (value.Grp == "U") {
							$scope.AvailabilityTemplates.u.templates.push(value)
						} else if (value.Grp == "H") {
							$scope.AvailabilityTemplates.h.templates.push(value)
						}
					})
					$scope.AvailabilityTemplatesTemp = [] // clear array as no longer needed

					// add 'custom' option for each group
					$scope.AvailabilityTemplates.a.templates.push({ EventName: "All day", EventFrom: "00:00", EventTo: "23:59", Grp: "A" })
					$scope.AvailabilityTemplates.a.templates.push({ EventName: "Custom", Grp: "A" })
					$scope.AvailabilityTemplates.u.templates.push({ EventName: "All day", EventFrom: "00:00", EventTo: "23:59", Grp: "U" })
					$scope.AvailabilityTemplates.u.templates.push({ EventName: "Custom", Grp: "U" })
					$scope.AvailabilityTemplates.h.templates.push({ EventName: "All day", EventFrom: "00:00", EventTo: "23:59", Grp: "H" })
					$scope.AvailabilityTemplates.h.templates.push({ EventName: "Custom", Grp: "H" })
				})
		}

		$scope.getAvailabilityTemplates()



	})
